import * as React from "react";
const SvgFiRrBonus = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-bonus_svg__a)">
      <path
        fill="#062147"
        d="M14.613 9.472A3 3 0 0 0 15 8c0-1.654-1.346-3-3-3h-1c-1.103 0-2 .897-2 2v6c0 1.103.897 2 2 2h2a3 3 0 0 0 1.613-5.528M11 7h1a1.001 1.001 0 0 1 0 2h-1zm2 6h-2v-2h2a1.001 1.001 0 0 1 0 2m10.615 5.58-3.2-3.199A9.93 9.93 0 0 0 22 10c0-5.514-4.486-10-10-10S2 4.486 2 10c0 1.991.591 3.843 1.598 5.403L.42 18.582a1.405 1.405 0 0 0-.31 1.546 1.4 1.4 0 0 0 1.317.884h1.562v1.562c0 .893.73 1.427 1.434 1.427.376 0 .72-.145.997-.42l3.944-3.944a10 10 0 0 0 2.636.364 10 10 0 0 0 2.664-.371l3.953 3.953c.275.273.62.418.995.418.705 0 1.434-.534 1.434-1.427v-1.562h1.562c.59 0 1.095-.339 1.316-.883a1.4 1.4 0 0 0-.31-1.548zM4.99 21.183v-2.171H2.817l2.033-2.033c.724.741 1.56 1.371 2.483 1.86l-2.345 2.345zM4 10c0-4.411 3.59-8 8-8s8 3.589 8 8-3.589 8-8 8-8-3.589-8-8m15.046 9.011v2.171l-2.356-2.356a10 10 0 0 0 2.476-1.867l2.052 2.052z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-bonus_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrBonus;
